import { Guid } from 'guid-typescript';
import { Provincia } from './Provincia';

export class Ciudad{
    id: string;
    nombre: string;
    codigoPostal: string;
    provincia: Provincia;
}